<div class="contenedor horizontal-center">
    <form
    action=""
    [formGroup]="formUpdaterDueDateMinute"
    (ngSubmit)="submit()"
    class="w-50"
    >
        <mat-form-field class="example-form-field">
            <mat-label>Nueva Fecha de Expiración</mat-label>
            <input matInput type='date' [value]="fecha | date:'YYYY-MM-dd'" (input)="onDateChange($event)">
        </mat-form-field> <br>
        <button
            mat-stroked-button
            color="primary"
            class="w-100" 
            [disabled]="!formUpdaterDueDateMinute.valid"
        >
            Actualizar
        </button>
    </form>
</div>